import React, { useState, useEffect } from 'react';
import './start-stop-container.scss';
import { SortableItem } from '../../atoms/sortableItem/sortableItem';
import { default as t } from '../../../utils/i18n';

function StartStopContainer(props) {
  const [startPanel, setStartPanel] = useState([]);
  const [stopPanel, setStopPanel] = useState([]);
  const [continuePanel, setContinuePanel] = useState([]);
  useEffect(() => {
    const panel1 = props?.data?.reportData?.optimisations_to_show?.start?.map((el, index) => {
      return {
        id: index,
        content: el.value,
        editable: false,
        show_in_export: el.show_in_export,
      };
    });
    setStartPanel(panel1);
    const panel2 = props?.data?.reportData?.optimisations_to_show?.stop?.map((el, index) => {
      return {
        id: index,
        content: el.value,
        editable: false,
        show_in_export: el.show_in_export,
      };
    });
    setStopPanel(panel2);
    const panel3 = props?.data?.reportData?.optimisations_to_show?.continue?.map((el, index) => {
      return {
        id: index,
        content: el.value,
        editable: false,
        show_in_export: el.show_in_export,
      };
    });
    setContinuePanel(panel3);
  }, []);

  const updatePanelsData = (comentryData, type = '', panelType) => {
    console.log(comentryData);
    if (panelType === 'start') {
      setStartPanel(comentryData);
    } else if (panelType === 'stop') {
      setStopPanel(comentryData);
    } else {
      setContinuePanel(comentryData);
    }
    if (type !== 'edit') {
      props?.updateReportPreference(panelType, comentryData);
    }
  };
  return (
    <>
      <div className="post-container">
       {(startPanel?.length && startPanel?.every(res => !res?.show_in_export) && props?.fromSnapShot ) ? '': <div className="cards">
          <p className="heading">{t('report.output.start')}</p>
          <div className="line"></div>
          <ul className="detail">
            {(startPanel?.length && startPanel?.every(res => !res?.show_in_export) && props?.fromSnapShot ) ? t('report.no.data.available'): startPanel?.map(el =>
              !el?.show_in_export && props?.fromSnapShot ? (
                ''
              ) : (
                <li>
                  <SortableItem
                    data={el}
                    isEdit={props?.isEdit}
                    panels={startPanel}
                    hideDrag={true}
                    fromSnapShot={props?.fromSnapShot}
                    setPanels={(data, type) => updatePanelsData(data, type, 'start')}
                  />
                </li>
              )
            )}
          </ul>
        </div>}
        {(stopPanel?.length && stopPanel?.every(res => !res?.show_in_export) && props?.fromSnapShot) ? '': <div className="cards">
          <p className="heading">{t('report.output.stop')}</p>
          <div className="line"></div>
          <ul className="detail">
            {(stopPanel?.length && stopPanel?.every(res => !res?.show_in_export) && props?.fromSnapShot) ? t('report.no.data.available'):stopPanel?.map(el =>
              !el?.show_in_export && props?.fromSnapShot ? (
                ''
              ) : (
                <li>
                  <SortableItem
                    data={el}
                    isEdit={props?.isEdit}
                    panels={stopPanel}
                    hideDrag={true}
                    fromSnapShot={props?.fromSnapShot}
                    setPanels={(data, type) => updatePanelsData(data, type, 'stop')}
                  />
                </li>
              )
            )}
          </ul>
        </div>}
        {(continuePanel?.length && continuePanel?.every(res => !res?.show_in_export) && props?.fromSnapShot) ? '':<div className="cards">
          <p className="heading">{t('report.output.continue.btn')}</p>
          <div className="line"></div>
          <ul className="detail">
            {(continuePanel?.length && continuePanel?.every(res => !res?.show_in_export) && props?.fromSnapShot) ? t('report.no.data.available'): continuePanel?.map(el =>
              !el?.show_in_export && props?.fromSnapShot ? (
                ''
              ) : (
                <li>
                  <SortableItem
                    data={el}
                    isEdit={props?.isEdit}
                    panels={continuePanel}
                    hideDrag={true}
                    fromSnapShot={props?.fromSnapShot}
                    setPanels={(data, type) => updatePanelsData(data, type, 'continue')}
                  />
                </li>
              )
            )}
          </ul>
        </div>}
      </div>
      <div className='the-insights'><span className='high-light'>*</span>{t('report.output.insights.note')} </div>
    </>
  );
}

export default StartStopContainer;
